import { useQuery } from '@tanstack/react-query';
import { GlobalReactQueryOptions } from '../../../config';
import { fetchBackIssues } from './fetchBackIssues';

const BACK_ISSUES_QUERY_KEY = 'epressBackIssues';

export const useBackIssues = (productId: string) => {
    const { data, ...rest } = useQuery([BACK_ISSUES_QUERY_KEY, productId], () => fetchBackIssues(productId), {
        ...GlobalReactQueryOptions
    });

    return { ...rest, data: { products: data?.hits ?? [], total: data?.totalHits ?? 0 } };
};
